import $ from 'jquery';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default.js';


export default function initPhotoSwipe(el, pswp) {
  el.each(function() {
    let items = [];
    $('figure', this).each((index, figure) => {
      $(figure).data('index', index);
      const $el = $('a', figure);
      const title = $('.carousel-caption', figure).text() || $('img', figure).attr('alt');
      items.push({
        src: $el.attr('href'),
        w: $el.data('width'),
        h: $el.data('height'),
        title,
      });
    });

    $(this).on('click', 'figure', function(event) {
        event.preventDefault();
        const $index = parseInt($(this).data('index'), 10);
        const options = {
            index: $index,
            bgOpacity: 0.8,
            showHideOpacity: true,
            fullscreenEl: false,
            zoomEl: false,
            shareEl: false,
        }
        const lightBox = new PhotoSwipe(pswp, PhotoSwipeUI_Default, items, options);
        lightBox.init();
    });

  });
}




// WEBPACK FOOTER //
// ./website/static_media/assets/js/photoswipe.js